module.exports = __webpack_public_path__ + "img/parking.62a472e7.svg";